import React, { useEffect, useState } from "react";
import { getPDFsForMieter } from "../api";
import Animation from "../components/Animation";

const PDFListPage = () => {
  const API_URL = "https://api.liendlhof.de/";
  const [pdfs, setPdfs] = useState([]);
  const [loading, setLoading] = useState(false);
  const mieter_id = localStorage.getItem("mieterId");

  const fetchPDFs = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
     // Wait 2 seconds artificially
    await new Promise((resolve) => setTimeout(resolve, 1000));
    try {
      const response = await getPDFsForMieter(mieter_id, token);
       // Wait 2 seconds artificially
      setPdfs(response);
    } catch (error) {
      console.error("Fehler beim Laden der PDFs:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPDFs();
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-6 py-8">
      <h1 className="text-3xl font-bold text-red-600 mb-6 text-center">
        📄 Deine PDF-Dokumente
      </h1>

      {loading ? (
        <div className="text-center text-gray-600">⏳ Lade Dokumente...</div>
      ) : pdfs.length === 0 ? (
        <div className="text-center text-gray-500">⚠️ Du hast keine verfügbaren PDFs.</div>
      ) : (
        <ul className="space-y-4">
          {pdfs.map((pdf) => (
            <li
              key={pdf.id}
              className="flex justify-between items-center bg-white border border-gray-200 rounded-lg shadow-sm p-4 hover:shadow-md transition-shadow"
            >
              <span className="text-gray-800 font-medium truncate">{pdf.title}</span>
              <a
                href={`${API_URL}${pdf.file}`}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-md text-sm font-semibold"
                download
              >
                ⬇ Herunterladen
              </a>
            </li>
          ))}
        </ul>
      )}
        <Animation loading={loading} />
    </div>
  );
};

export default PDFListPage;
